<template>
  <v-layout row>
    <v-dialog
      :fullscreen="fullScreen"
      :key="automation.hexId + 'dialog'"
      v-model="inputBox"
      content-class="honey-popup"
      :disabled="disabled"
    >
      <v-btn
        :class="
          !$vuetify.dark ? 'secondary text-capitalize' : 'text-capitalize'
        "
        :color="$vuetify.dark ? 'secondary' : ''"
        style="border-radius: 5px"
        flat
        :key="automation.hexId + 'button'"
        v-if="showLabel"
        slot="activator"
        :disabled="disabled"
        :outline="$vuetify.dark"
      >
        New Request
      </v-btn>
      <v-btn flat icon v-else slot="activator" :disabled="disabled">
        <v-icon color="secondary" medium>mdi-run</v-icon>
      </v-btn>

      <v-card>
        <v-toolbar dense :fixed="fullScreen">
          <v-btn flat icon @click="inputBox = false">
            <v-icon>close</v-icon>
          </v-btn>
          <div class="text-lg-left beez-bold ">
            Start Automation Service
          </div>
        </v-toolbar>
        <v-card-title v-if="automation.proposals">
          <span class="subheading"
            >Please provide the inputs for the following fields</span
          >
        </v-card-title>
        <v-card-title v-else>
          <span class="subheading">Please confirm to start the automation</span>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-flex xs12 v-if="askBusinessReason">
              <v-textarea
                outline
                autofocus
                color="secondary"
                class="pa-3"
                textarea
                v-model="businessReason"
                label="Business Reason"
              />
            </v-flex>
            <div v-if="fullScreen" style="padding-bottom: 20px"></div>
            <proposal-renderer
              :proposals="proposals"
              :readonly="false"
              :cancel="true"
              @submit="executeAutomation"
              :ask-business-reason="askBusinessReason"
              @cancel="inputBox = false"
            >
            </proposal-renderer>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ProposalRenderer from '@/components/common/ProposalRenderer'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: { ProposalRenderer },
  name: 'service-runner',
  props: {
    automation: Object,
    askBusinessReason: {
      type: Boolean,
      default: false
    },
    showLabel: Boolean,
    type: String,
    disabled: Boolean,
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputBox: false,
      proposals: [],
      proposal: [],
      businessReason: '',
      executionLogs: [],
      showProgress: false,
      showAlert: false
    }
  },

  computed: {
    ...mapGetters({
      can: 'can'
    })
  },

  watch: {
    automation() {
      this.proposals = JSON.parse(JSON.stringify(this.automation.proposals))
    }
  },
  mounted() {
    this.proposal = []
    this.proposals = JSON.parse(JSON.stringify(this.automation.proposals))
    this.businessReason = ''
  },

  methods: {
    executeAutomation(model) {
      this.inputBox = false
      this.showProgress = true
      let triggerJson = {}
      if (this.type === 'Bot') {
        triggerJson.botInputs = {}
        let inputArray = Object.keys(model)
        for (let i = 0; i < inputArray.length; i++) {
          triggerJson.botInputs[inputArray[i]] = {
            value: model[inputArray[i]],
            type: 'STRING',
            objectTypeName: 'java.lang.String',
            flowVariable: false
          }
        }

        this.$store
          .dispatch('queueBot', {
            body: triggerJson,
            hexId: this.automation.hexId
          })
          .then(() => {
            this.$store.dispatch('directNotification', {
              type: 'success',
              message: 'Bot execution request raised Successfully',
              description:
                'Bot execution request ' +
                this.automation.name +
                ' has been raised Successfully',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
            this.$emit('submit')
          })
          .catch(e => {
            this.$store.dispatch('directNotification', {
              type: 'error',
              message: 'Bot execution request has Failed',
              description:
                'The Bot execution request for - ' +
                this.automation.name +
                ' has failed - ' +
                e.response
                  ? e.response.data.message
                  : 'Error unknown! Kindly retry',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          })
      } else if (this.type === 'Workflow') {
        triggerJson.isForeground = true
        triggerJson.workflowId = this.automation.hexId
        triggerJson.workflowVariables = {}
        let inputArray = Object.keys(model)
        for (let i = 0; i < inputArray.length; i++) {
          triggerJson.workflowVariables[inputArray[i]] = {
            value: model[inputArray[i]],
            type: 'STRING',
            objectTypeName: 'java.lang.String',
            flowVariable: false
          }
        }

        this.$store
          .dispatch('queueWorkflow', {
            body: triggerJson,
            hexId: this.automation.hexId
          })
          .then(() => {
            this.$store.dispatch('directNotification', {
              type: 'success',
              message: 'Workflow execution request raised Successfully',
              description:
                'Workflow execution request ' +
                this.automation.name +
                ' has been raised Successfully',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
            this.$emit('submit')
          })
          .catch(e => {
            this.$store.dispatch('directNotification', {
              type: 'error',
              message: 'Workflow execution request has Failed',
              description:
                'The Workflow execution request for - ' +
                this.automation.name +
                ' has Failed - ' +
                e.response
                  ? e.response.data.message
                  : 'Error unknown! Kindly retry',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          })
      } else if (this.type === 'SelfService') {
        let automationRequest = {}
        automationRequest.serviceId = this.automation.hexId
        automationRequest.variables = {}
        automationRequest.businessReason = this.businessReason
        let inputArray = Object.keys(model)
        for (let i = 0; i < inputArray.length; i++) {
          automationRequest.variables[inputArray[i]] = {
            value: model[inputArray[i]],
            type: 'STRING',
            objectTypeName: 'java.lang.String',
            flowVariable: false
          }
        }
        this.$store
          .dispatch('raiseAutomationRequest', automationRequest)
          .then(() => {
            this.$store.dispatch('directNotification', {
              type: 'success',
              message: 'Automation Request raised Successfully',
              description:
                'The Automation Request for Service - ' +
                this.automation.name +
                ' has been raised',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
            this.$emit('submit')
          })
          .catch(e => {
            this.$store.dispatch('directNotification', {
              type: 'error',
              message: 'Automation Request has Failed',
              description:
                'The Automation Request for Service - ' +
                this.automation.name +
                ' has failed - ' +
                e.response
                  ? e.response.data.message
                  : 'Error unknown! Kindly retry',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          })
      }
    }
  }
}
</script>
